import { Box, RadioButton, Text } from '@factorialco/deprecated-design-system'
import { DataSchemaItemFragment, WorkingConditionItemFragment } from 'generated/resources/graphql'
import { ContractsBankHolidayTreatmentEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { WizardData } from '../types'
import WorkingConditionValueTooltip from './WorkingConditionValueTooltip'

interface Props {
  field: DataSchemaItemFragment
  fieldName: keyof WizardData
  data: WizardData
  isExistingUser?: boolean
  onChangeField: (fieldName: string, value: string) => void
  workingConditionItems?: WorkingConditionItemFragment[]
  workingConditionName?: string
}

export const BankHolidayTreatmentField = ({
  fieldName,
  field,
  data,
  onChangeField,
  workingConditionItems,
  workingConditionName,
}: Props) => {
  const getWorkingConditionValue = (name: string) => {
    return workingConditionItems?.find((item) => `contracts_${item.name}` === name)?.value
  }

  const bankHolidayValueFromWC = getWorkingConditionValue(field.fieldName)

  const bankHolidayTreatmentOptions: {
    label: string
    value: ContractsBankHolidayTreatmentEnum
  }[] = [
    {
      label: i18n.t(
        'add_employee_modal.contract_information_step.fields.bank_holidays_tratment.non_workable'
      ),
      value: 'non_workable',
    },
    {
      label: i18n.t(
        'add_employee_modal.contract_information_step.fields.bank_holidays_tratment.workable'
      ),
      value: 'workable',
    },
  ]

  return (
    <Box gap="s8">
      <Box gap="s2">
        <Text.Normal color="grey1000" weight="medium" size="200">
          {i18n.t(
            'add_employee_modal.contract_information_step.fields.bank_holidays_tratment.label'
          )}
        </Text.Normal>
      </Box>
      <Box gap="s8">
        {bankHolidayTreatmentOptions.map((option) => {
          return (
            <Box key={option.value} position="relative">
              <RadioButton
                label={option.label}
                size="small"
                onChange={() => onChangeField(fieldName, option.value)}
                value={data.contractsBankHolidayTreatment || ''}
                checked={
                  data[fieldName] === option.value ||
                  (data[fieldName] === undefined && option.value === 'non_workable')
                }
              />
              {data[fieldName] === option.value && bankHolidayValueFromWC && (
                <Box position="absolute" style={{ right: '38px' }}>
                  <WorkingConditionValueTooltip
                    linked={data[fieldName] === bankHolidayValueFromWC}
                    onClick={() => onChangeField(fieldName, bankHolidayValueFromWC || '')}
                    workingConditionName={workingConditionName}
                  />
                </Box>
              )}
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
